'use client';

import { Price as SparkyPrice } from '@petsmart-ui/sparky';

import { PricePolicyDrawer } from '@libs/shared-ui';

import { usePrice } from './model';
import { Afterpay } from './ui';
import './Price.scss';

export const Price = () => {
    const { values, variant, pricePolicy } = usePrice();
    return (
        <>
            <div className="product-price">
                <SparkyPrice
                    className="product-price-sparky"
                    size="xl"
                    data-testid="sparky-price"
                    values={values}
                    variant={variant}
                />
                {pricePolicy && <PricePolicyDrawer />}
            </div>
            <Afterpay data-testid="afterpay" />
        </>
    );
};
